// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSearch_container__6ru9u","input":"ProductSearch_input__2Xrat"};